module.exports = __webpack_public_path__ + "static/media/3.107123d5.png";